<template>
  <div>
    <div class="app-block-group">
      <a :class="$route.path.split('/')[2] ? 'small app-block running desktop' : 'large app-block running desktop'"
        v-for="candidate in copy.candidates"
        v-if="candidate.status == 'active'"
        :id="candidate.short_name + '-block'"
        :href="'./index.html#/candidates/'+candidate.short_name+'#Toggle'">
        <div class="app-block-image">
          <img :src="'./assets/headshots/'+candidate.short_name+'.png'"></img>
        </div>
        <div class="app-block-text">
          <h5>{{ candidate.name }}</h5>
        </div>
      </a>
      <div :class="$route.path.split('/')[2] ? 'small dropout-label-div' : 'large dropout-label-div'">
        <h4 class="dropout-label">Dropped out</h4>
      </div>
      <a :class="$route.path.split('/')[2] ? 'small app-block out desktop' : 'large app-block out desktop'"
        v-for="candidate in copy.candidates"
        v-if="candidate.status != 'active'"
        :id="candidate.short_name + '-block'"
        :href="'./index.html#/candidates/'+candidate.short_name+'#Toggle'">
        <div class="app-block-image">
          <img :src="'./assets/headshots/'+candidate.short_name+'.png'"></img>
        </div>
        <div class="app-block-text">
          <h5>{{ candidate.name }}</h5>
        </div>
      </a>
      <a :class="$route.path.split('/')[2] ? 'small app-block all desktop' : 'large app-block all desktop'" href="./index.html#/candidates">
        <div class="app-block-text"><h5>See all</h5></div>
      </a>
      <div class="container">
        <div :class="$route.path.split('/')[2] ? 'small app-block-group filter-bar mobile' : 'large app-block-group filter-bar mobile'">
          <select id="candidateSelect" name="candidateSelect" onchange="location = this.value;">
            <option v-for="candidate in copy.candidates"
              :value="'./index.html#/candidates/'+candidate.short_name"
              :selected="$route.path.split('/')[2] == candidate.short_name ? 'selected' : ''">
              {{ candidate.name }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <router-view v-bind:copy="copy""></router-view>
  </div>
</template>

<script>

  module.exports =  {
    name: 'candidates',
    mounted: function() {
      var selected = this.$route.path.split('/')[2] + '-block';
      selected ? document.getElementById(selected).classList.add("selected") : '';
    },
    updated: function() {
      var selected = this.$route.path.split('/')[2] + '-block';
      document.getElementsByClassName("selected").length > 0 ? document.getElementsByClassName("selected")[0].classList.remove("selected") : '';
      selected ? document.getElementById(selected).classList.add("selected") : '';
    },
    props: ['copy']
  }

</script>

<style scoped></style>
